import React, { memo, useMemo, useState } from "react";

import { Popup } from "../../../../../common";
import {
	ConnectionDetails as Details,
	ConnectionErrorBoundary,
} from "../../../../../ConnectionQuality";

import Tracker from "./components/Tracker";

const popupOffset = { x: -12, y: 44 };

/**
 * Holds only the open state: the icon and the panel read the store
 * themselves, so a new ping does not hand Popup new children (uikit
 * Popover updates its float container while rendering).
 */
const ConnectionQuality = memo(() => {
	const [open, setOpen] = useState(false);

	// Same elements on every render: opening must not change the content.
	// Each part has its own guard: the panel renders in the root float
	// container, outside this tree.
	const tracker = useMemo(
		() => (
			<ConnectionErrorBoundary>
				<Tracker />
			</ConnectionErrorBoundary>
		),
		[],
	);
	const details = useMemo(
		() => (
			<ConnectionErrorBoundary>
				<Details />
			</ConnectionErrorBoundary>
		),
		[],
	);

	return (
		<Popup
			useHoverControl
			containerId="header"
			open={open}
			offset={popupOffset}
			tracker={tracker}
			onChangeOpen={setOpen}
		>
			{details}
		</Popup>
	);
});

export default ConnectionQuality;
